module.exports = __webpack_public_path__ + "static/media/bg_log.a15d6db3.webp";